import { Controller } from "@hotwired/stimulus"
import TomSelect from "@lib/custom-tom-select"

// Connects to data-controller="user-form"
export default class extends Controller {
  
  static targets = ["clinics", "clinic", "duty", "orderNumberWrapper", "orderNumber"]

  connect() {
    // Destroy existing Tom Select instances if they exist (e.g., from previous connection)
    if (this.clinicsTarget.tomselect) {
      this.clinicsTarget.tomselect.destroy()
    }
    if (this.clinicTarget.tomselect) {
      this.clinicTarget.tomselect.destroy()
    }

    this.clinicsSelect = new TomSelect(this.clinicsTarget, {
      onItemAdd: this.onClinicAdd.bind(this),
      onItemRemove: this.onClinicRemove.bind(this)
    })
    
    this.clinicSelect = new TomSelect(this.clinicTarget)
  }

  disconnect() {
    if (this.clinicsSelect) {
      this.clinicsSelect.destroy()
    }
    if (this.clinicSelect) {
      this.clinicSelect.destroy()
    }
    this.element.removeEventListener("turbo:load", () => {})
  }
  
  onClinicAdd(value, item) {
    const { id, name } = this.clinicsSelect.options[value]
    this.clinicSelect.addOption({ id, name })
    
    // If clinic value is empty we set it to this new option
    if (!this.clinicSelect.getValue()) {
      this.clinicSelect.setValue(id)
    }
  }

  onClinicRemove(value, item) {
    this.clinicSelect.removeOption(value)
    this.clinicSelect.removeItem(value)
    
    // If there is only one clinic option, set it as the value (options is an object with id being the key)
    if (Object.keys(this.clinicSelect.options).length === 1) {
      this.clinicSelect.setValue(Object.keys(this.clinicSelect.options)[0])
    }
  }
  
  // If the user is an admin or superadmin, all clinics will be available, we want to indicate that and disable the selection
  onRoleChange(event) {
    const clinicsLabel = this.clinicsTarget.parentElement.querySelector("label")
    
    if (["admin", "superadmin"].includes(event.target.value)) {
      // Set all options as selected
      this.clinicsSelect.setValue(Object.keys(this.clinicsSelect.options))
      this.clinicsSelect.disable()
      // this.clinicsSelect.clearSelect()
      clinicsLabel.textContent = "Cliniques - Accès à toutes les cliniques"
    } else {
      this.clinicsSelect.enable()
      this.clinicsSelect.clear()
      clinicsLabel.textContent = "Cliniques"
    }
  }

  onVetChange(event) {
    const isVet = event.target.value === "1"
    this.dutyTargets.forEach(target => target.disabled = !isVet)
    this.orderNumberWrapperTarget.style.display = isVet ? "contents" : "none"
    this.orderNumberTarget.disabled = !isVet
  }

}
